import Input from "@/components/core/Input/Input"
import { useEffect, useState } from "react"
import Button from "@/components/core/Button/Button"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import calenderIcon from "@/public/icons/calendar.svg"
import {
  validNumber,
  validText,
  validPincode,
  validPhone,
} from "@/utils/validate"
import { getDetailsFromZipCode } from "@/utils/findStore"
import OtpFields from "@/components/Shared/Otp/v1"
import editIcon from "@/public/icons/edit.svg"
import { isMobile } from "react-device-detect"
import { checkNumberExists } from "@/utils/enquiry"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import { useDispatch, useSelector } from "react-redux"
import { getOtpAnalytics } from "../analytics"
import { isBrandTransact } from "@/utils/index"

const ContactInfo = props => {
  const [states, setStates] = useState({})
  const [verifyOTP, setVerifyOTP] = useState(false)
  const [changeNumber, setChangeNumber] = useState(false)
  const [stateCityDisabled, setStateCityDisabled] = useState(true)
  const {
    activeTab,
    staticText,
    error,
    data,
    setData,
    setError,
    serviceRequest,
    productDetails,
    onSubmit,
    resetData,
    isEnabled,
    verified,
    setVerified,
    setPincodeValid,
  } = props
  const dispatch = useDispatch()
  const { isAuth, user } = useSelector(selectAuthState)
  const [userDetails, setUserDetails] = useState(false)
  const [numberEditable, setNumberEditable] = useState(true)

  useEffect(() => {
    if (data?.pincode) {
      const response = getDetailsFromZipCode(data?.pincode)
      response.then(resp => {
        const { statusCode, result = {} } = resp
        if (statusCode === 200) {
          const res = result?.data ?? {}
          setStates(res)
          setError({
            ...error,
            city: null,
            state: null,
          })
          setPincodeValid(false)
          setStateCityDisabled(true)
        } else {
          setStateCityDisabled(false)
        }
        return { statusCode }
      })
    } else {
      setStates({})
    }
  }, [data?.pincode])

  useEffect(() => {
    if (states) {
      const state = states?.state ?? ""
      const city = states?.city ?? ""
      setData({
        ...data,
        city: city,
        state: state,
      })
    }
  }, [states])

  const onInputChange = e => {
    const { id, value } = e.target
    const field = id.split("-")
    setData({
      ...data,
      [field[2]]: value?.replace(/[&%\\]/g, ''),
    })
  }

  const onChangePincode = e => {
    const { value } = e.target
    if (value === "" || validNumber(value)) {
      setData({
        ...data,
        pincode: value,
      })
    }
  }

  const onChangeCity = e => {
    const { value } = e.target
    setData({
      ...data,
      city: value,
    })
  }

  const onChangeState = e => {
    const { value } = e.target
    setData({
      ...data,
      state: value,
    })
  }

  const onChangeNumber = e => {
    const { value } = e.target
    if (value === "" || validNumber(value)) {
      setData({
        ...data,
        atlernateNumber: value,
      })
    }
  }

  const onNameChange = e => {
    const { id, value } = e.target
    const field = id.split("-")
    if (value === "" || validText(value)) {
      setData({
        ...data,
        [field[2]]: value,
      })
    }
  }

  const changeDateFormat = date => {
    if (date) {
      const dateVal = moment(date).format("YYYY-MM-DD")
      setData({ ...data, dateInvoice: dateVal })
      setError({})
    } else {
      setData({ ...data, dateInvoice: "" })
    }
  }

  const handleServiceRequest = serviceRequest => {
    setData({ ...data, serviceRequest })
    setError({
      ...error,
      serviceRequest: false,
    })
  }

  const handleProductDetails = productDetails => {
    setData({ ...data, productDetails })
    setError({
      ...error,
      productDetails: false,
    })
  }

  const serviceList = serviceRequest.map(data => data?.text)
  const productList = productDetails.map(data => data?.text)

  const isVal =
    data?.state?.trim()?.length > 0 && data?.city?.trim()?.length > 0

  const isPincodeValid = validPincode(data?.pincode ?? "")
    ? true
    : isVal
    ? false
    : true

  const validateNumber = text => {
    if (validPhone(text)) {
      setData({
        ...data,
        phone: {
          ...data?.phone,
          error: false,
          message: "",
        },
      })
    } else {
      setData({
        ...data,
        phone: {
          ...data?.phone,
          error: true,
          message: staticText?.validPhone ?? "",
        },
      })
    }
  }

  useEffect(() => {
    if (sessionStorage?.getItem("okt.user.temp.details")) {
      let dataValue = atob(sessionStorage?.getItem("okt.user.temp.details"))
      setData({
        ...data,
        phone: { ...data?.phone, value: dataValue },
      })
    }
  }, [])

  useEffect(() => {
    if (isAuth && user) {
      setVerified(true)
      setVerifyOTP(false)
      localStorage.removeItem("numberAlreadyExists")
      const { login = "", firstName = "", lastName = "", sub } = user
      setData({
        ...data,
        phone: { ...data?.phone, value: login, error: false, message: "" },
        fname: firstName,
        lname: lastName,
        email: sub,
      })
      setNumberEditable(false)
    }
  }, [isAuth, user])

  const onChangeNumberMobile = e => {
    const { value } = e.target
    if (value === "" || validNumber(value)) {
      setData({
        ...data,
        phone: { ...data?.phone, value: value, error: false, message: "" },
      })
    }
  }

  const isValidPhone = validPhone(data?.phone?.value)

  const changeNumberHandler = async () => {
    setVerifyOTP(true)
    setChangeNumber(true)
  }
  const verifiedNumber = () => {
    setVerified(true)
    setVerifyOTP(false)
    if (!isAuth) setNumberEditable(true)
    else setNumberEditable(false)
  }
  const getOTP = async () => {
    let { numberExists, factorId, userId } = await checkNumberExists(
      data?.phone?.value
    )
    const isBrandOrTransact = isBrandTransact()
    if (!isBrandOrTransact && numberExists && !isAuth) {
      dispatch(setAuthModalVisibility({ show: true }))
    } else {
      if (isValidPhone) {
        setUserDetails({ factorId: factorId, userId: userId })
        setVerifyOTP(true)
        setChangeNumber(false)
      } else setVerifyOTP(false)
    }
    getOtpAnalytics()
  }

  return (
    <div className="container mb-40">
      {activeTab === "Service Request" && (
        <>
          <div className="mx-0 flex-mobile">
            {!verified && (
              <div className={`country-code`}>
                <Input
                  disabled
                  customClass="customer-support-country-code-input"
                  id="contact-user-country-code"
                  type="text"
                  value={data?.countryCode}
                />
              </div>
            )}

            <div className={!verified ? "phone-number" : "phone-number edit"}>
              <Input
                disabled={verified}
                customClass="customer-support-inputfield"
                id="contact-user-phone"
                type="text"
                value={
                  verified ? `+91 ${data?.phone?.value}` : data?.phone?.value
                }
                maxLength={10}
                placeholder={staticText?.mobile}
                label={staticText?.mobile}
                onChange={onChangeNumberMobile}
                onInput={onChangeNumberMobile}
                autoFocus={true}
                showError={data?.phone?.error}
                errorMessage={data?.phone?.message}
                onBlur={() => validateNumber(data?.phone?.value)}
                suffix={
                  verified &&
                  numberEditable && (
                    <img
                      src={editIcon?.src}
                      alt=""
                      aria-hidden="true"
                      onClick={changeNumberHandler}
                      style={{ cursor: "pointer" }}
                    />
                  )
                }
              />
            </div>
            {!verified && (
              <div className="otp-button">
                <p
                  className={`${isValidPhone && "--active"}`}
                  tabIndex={0}
                  onClick={getOTP}
                >
                  Get OTP
                </p>
              </div>
            )}
          </div>

          <p
            className={`${
              !verified && isValidPhone
                ? "mobile-verified-text --error"
                : "mobile-verified-text"
            }`}
          >
            {verified ? staticText?.mobileVerified : staticText?.verifyMobile}
          </p>

          <div className="row mx-0">
            <div
              className={`col-12 col-sm-6 col-md-6 pl-0 ${
                isMobile ? "pr-0" : "pr-10"
              }`}
            >
              <Input
                id="contact-user-fname"
                type="text"
                customClass="customer-support-inputfield"
                value={data.fname}
                maxLength={40}
                placeholder={staticText?.fname}
                label={staticText?.fname}
                onChange={onNameChange}
                onInput={onNameChange}
                showError={error.fname}
                errorMessage={error.fname}
                onBlur={() => props.onBlur("fname")}
              />
            </div>
            <div
              className={`col-12 col-sm-6 col-md-6 pr-0 ${
                isMobile ? "pl-0" : "pl-10"
              }`}
            >
              <Input
                id="contact-user-lname"
                type="text"
                customClass="customer-support-inputfield"
                value={data.lname}
                maxLength={40}
                placeholder={staticText?.lname}
                label={staticText?.lname}
                onChange={onNameChange}
                onInput={onNameChange}
                showError={error.lname}
                errorMessage={error.lname}
                onBlur={() => props.onBlur("lname")}
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-email"
                type="text"
                value={data.email}
                maxLength={60}
                prefix={
                  <img src={"/icons/email.svg"} alt="" aria-hidden="true" />
                }
                placeholder={staticText?.email}
                label={staticText?.email}
                onChange={onInputChange}
                onInput={onInputChange}
                showError={error.email}
                errorMessage={error.email}
                onBlur={() => props.onBlur("email")}
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-address"
                type="text"
                maxLength={100}
                value={data.address}
                placeholder={staticText?.address}
                label={staticText?.address}
                onChange={onInputChange}
                onInput={onInputChange}
                showError={error.address}
                errorMessage={error.address}
                onBlur={() => props.onBlur("address")}
                autoComplete={true}
              />
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-landmark"
                type="text"
                maxLength={50}
                value={data.landmark}
                placeholder={staticText?.landmark}
                label={staticText?.landmark}
                onChange={onInputChange}
                onInput={onInputChange}
                onBlur={() => props.onBlur("landmark")}
              />
            </div>
          </div>

          <div className="row mx-0">
            <div
              className={`col-12 col-sm-6 col-md-6 pl-0 ${
                isMobile ? "pr-0" : "pr-10"
              }`}
            >
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-pincode"
                type="text"
                placeholder={staticText?.pincode}
                label={staticText?.pincode}
                value={data.pincode}
                maxLength={6}
                autoComplete={true}
                onChange={onChangePincode}
                onInput={onChangePincode}
                showError={error.pincode}
                errorMessage={error.pincode}
                onBlur={() => props.onBlur("pincode")}
              />
            </div>
            <div
              className={`col-12 col-sm-6 col-md-6 pr-0 ${
                isMobile ? "pl-0" : "pl-10"
              }`}
            >
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-state"
                type="text"
                placeholder={staticText?.state}
                label={staticText?.state}
                value={data.state}
                showError={error.state}
                errorMessage={error.state}
                onChange={onChangeState}
                onInput={onChangeState}
                disabled={stateCityDisabled}
                onBlur={() => props.onBlur("state")}
              />
            </div>
          </div>

          <div className="row mx-0">
            <div
              className={`col-12 col-sm-6 col-md-6 pl-0 ${
                isMobile ? "pr-0" : "pr-10"
              }`}
            >
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-city"
                type="text"
                placeholder={staticText?.city}
                label={staticText?.city}
                value={data.city}
                showError={error.city}
                errorMessage={error.city}
                onChange={onChangeCity}
                onInput={onChangeCity}
                disabled={stateCityDisabled}
                onBlur={() => props.onBlur("city")}
              />
            </div>
            <div
              className={`col-12 col-sm-6 col-md-6 pr-0 ${
                isMobile ? "pl-0" : "pl-10"
              }`}
            >
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-atlernateNumber"
                type="text"
                maxLength={10}
                placeholder={staticText?.alternateNumber}
                label={staticText?.alternateNumber}
                prefix={
                  <img
                    src={"/icons/phone-icon.svg"}
                    alt=""
                    aria-hidden="true"
                  />
                }
                value={data.atlernateNumber}
                onChange={onChangeNumber}
                onInput={onChangeNumber}
                showError={error.atlernateNumber}
                errorMessage={error.atlernateNumber}
                onBlur={() => props.onBlur("atlernateNumber")}
              />
            </div>
          </div>

          <div className="row-response">
            <div className={`col-response`}>
              <div className="kf-react-datepicker">
                <DatePicker
                  value={Date.parse(data?.dateInvoice)}
                  selected={Date.parse(data?.dateInvoice)}
                  dateFormat="dd/MM/yyyy"
                  customInput={
                    <Input
                      customClass="customer-support-inputfield"
                      id={props?.id}
                      prefix={
                        <img src={calenderIcon?.src} alt="calendar-icon" />
                      }
                      value={props?.value}
                      placeholder={`${staticText?.dateOfInvoice}`}
                      label={`${staticText?.dateOfInvoice}`}
                      showError={error.dateInvoice}
                      errorMessage={error.dateInvoice}
                      onChange={props?.onChange}
                      onBlur={props?.onBlur}
                    />
                  }
                  id={"contact-installed-installDate"}
                  onChange={date => changeDateFormat(date)}
                  minDate={new Date("01/01/2001")}
                  maxDate={new Date()}
                  onBlur={() => props?.onBlur("installDate")}
                  isClearable={!!data?.dateInvoice}
                />
              </div>
            </div>
            <div className={`col-response`}>
              <Dropdown
                id="contact-installed-serviceRequest"
                customClass="input-field customer-support-inputfield"
                data={serviceList}
                value={data.serviceRequest}
                label={staticText?.serviceRequest}
                onChange={serviceRequest =>
                  handleServiceRequest(serviceRequest)
                }
                showError={error.serviceRequest}
                onBlur={() => props.onBlur("serviceRequest")}
                errorMessage={error.serviceRequest}
              />
            </div>
          </div>
          <div className="row mx-0 mb-20">
            <div className="col-12 px-0">
              <Dropdown
                id="contact-installed-productDetails"
                customClass="input-field customer-support-inputfield"
                data={productList}
                value={data.productDetails}
                label={staticText?.productDetails}
                onChange={productDetails =>
                  handleProductDetails(productDetails)
                }
                showError={error.productDetails}
                onBlur={() => props.onBlur("productDetails")}
                errorMessage={error.productDetails}
              />
            </div>
          </div>

          <div className="row mx-0">
            <div className="col-12 px-0">
              <Input
                customClass="customer-support-inputfield"
                id="contact-user-reportIssue"
                type="text"
                maxLength={250}
                placeholder={staticText?.reportIssues}
                label={staticText?.reportIssues}
                value={data.reportIssue}
                onChange={onInputChange}
                onInput={onInputChange}
                showError={error.reportIssue}
                errorMessage={error.reportIssue}
                onBlur={() => props.onBlur("reportIssue")}
              />
            </div>
          </div>

          <div className="row-response flex-gap">
            <div className={`col-response`}>
              <Button
                customClass={"kf-react-button"}
                role="button"
                id="submit-contact-form-button"
                onClick={onSubmit}
                type="black"
                label={staticText?.submit}
                flexible
                disabled={isEnabled}
              />
            </div>
            <div className={`col-response`}>
              <Button
                customClass={"kf-react-button"}
                role="button"
                id="submit1-contact-form-button"
                type="ghost"
                onClick={resetData}
                label={staticText?.cancel}
                flexible
              />
            </div>
          </div>
        </>
      )}

      {verifyOTP && (
        <OtpFields
          page="support:contact"
          handleClose={() => setVerifyOTP(false)}
          showModal={verifyOTP}
          staticTexts={staticText}
          mobile={data?.phone?.value}
          userData={data}
          setData={setData}
          verifiedNumber={verifiedNumber}
          changeMobileNumber={changeNumber}
          userDetails={userDetails}
        />
      )}
    </div>
  )
}

export default ContactInfo
